<template>
    <div>
        <painel-erros-dotacoes
            :dotacoes="entregas ? entregas.rateiosEntregas : []"
        ></painel-erros-dotacoes>
        <entregas
            :entregas="entregas ? entregas.entregas : []"
            :movimentosServicos="movimentosServicos"
        >
            <template slot="entregaAcoes" slot-scope="data">
                <slot name="entregaAcoes" v-bind="data"></slot></template
        ></entregas>
    </div>
</template>

<script>
import PainelErrosDotacoes from './PainelErrosDotacoes'
import Entregas from '../entregas/Entregas2'

export default {
    props: {
        entregas: {
            type: Object,
            default: () => {}
        },

        movimentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            tabIndex: 0
        }
    },

    methods: {},

    computed: {},

    created() {},

    watch: {},

    components: {
        PainelErrosDotacoes,
        Entregas
    }
}
</script>
